export const PERMISSION_DENIED_ERROR_CODES = ['PERMISSION_DENIED', 'PREMIUM_PERMISSION_DENIED'];
export const ErrorsUtils = {
  isNetworkError: error => error instanceof Error && error.message === 'Network Error',
  isPermissionDeniedError: error => {
    var _generalError$respons;
    if (!error) {
      return false;
    }
    if (error instanceof Error) {
      return error.message.includes('401') || error.message.includes('403');
    }
    const generalError = error;
    return ((_generalError$respons = generalError.response) == null ? void 0 : _generalError$respons.code) === 403;
  },
  getErrorType: error => {
    if (ErrorsUtils.isNetworkError(error)) {
      return 'ConnectionError';
    }
    if (ErrorsUtils.isPermissionDeniedError(error)) {
      return 'PermissionErrorWrapper';
    }
    return 'TechnicalError';
  }
};
//# sourceMappingURL=errors.utils.js.map